import { render } from "./tipohabitacion.vue?vue&type=template&id=f9fa4738&scoped=true"
import script from "./tipohabitacion.vue?vue&type=script&lang=js"
export * from "./tipohabitacion.vue?vue&type=script&lang=js"

import "./tipohabitacion.vue?vue&type=style&index=0&id=f9fa4738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fa4738"]])

export default __exports__